<template>
  <!-- <AppCard>
    <AppTitle>工廠廢氣稽核表</AppTitle>
    <AppChips :value="???" />
    <AppSpecs :value="" />
    <AppBtn icon="">
      建立稽核
    </AppBtn>

  <div class="SystemClassItemList__container">
    <slot :system="systemClass"></slot>
  </div>
  </AppCard> -->
  <router-link
    :class="{isloading:isloading, disableRouterLink:to ? false: true}"
    :to="to"
    :tag="tag"
    class="license-card"
  >
    <div
      v-if="cardContent.isCardBorderTopHasColor && !isloading"
      class="license-card_top-bar-declaration"
    />
    <div class="card-container">
      <div
        v-if="isloading"
        class="isloading-wrap"
      >
        <SkeletonAnimate class="skelete-1 skekete" />
        <SkeletonAnimate class="skelete-2 skekete" />
        <SkeletonAnimate class="skelete-3 skekete" />
        <SkeletonAnimate class="skelete-4 skekete" />
        <SkeletonAnimate class="skelete-5 skekete" />
      </div>
      <div
        v-if="!isloading"
        class="license-card__chips"
      >
        <ContentChip
          v-if="cardContent.overdue"
          :text-label="cardContent.overdue"
          red
        />
        <ContentChip
          v-if="cardContent.status"
          :text-label="cardContent.status"
          yellow
        />
        <ContentChip
          v-for="(badge,badgeIndex) in cardContent.badges"
          :key="badgeIndex"
          :text-label="badge.text"
          :color="badge.color"
        />
      </div>
      <div
        v-if="!isloading"
        class="card-title"
      >
        {{ cardContent.name }}
      </div>
      <div
        v-if="cardContent.system_subclasses && cardContent.system_subclasses.length>0 && !isloading"
        class="chips-group"
      >
        <div
          v-for="(tag_e,tag_k) in cardContent.system_subclasses"
          :key="tag_k"
        >
          <ContentChip
            :leading-icon="tag_e.leadingIcon"
            :leading-img="tag_e.icon"
            :text-label="tag_e.name"
            :bold="tag_e.bold"
          />
        </div>
      </div>
      <div
        v-if="!isloading"
        class="license-card-content-list"
      >
        <div
          v-for="(list_e,list_k) in cardContent.content"
          :key="list_k"
          class="license-card-list-item"
        >
          <p class="item-title">
            {{ $t(list_e.title) }}
          </p>
          <p class="item-text">
            {{ list_e.text }} <i :class="list_e.icon" />
          </p>
        </div>
      </div>
      <div
        v-if="hasBtn"
        class="license-card_btn"
      >
        <WsButton001
          width-stretch
          flat-button
          :leading-icon="btnIcon"
          @click="btnClick()"
        >
          {{ $t(btnText) }}
        </WsButton001>
      </div>
    </div>
    <div
      v-if="isRemindDateExist && cardContent.remind && !isloading"
      class="date-remind"
      :class="{warning:remindWarning}"
    >
      <i class="icon-remind-outline" />
      <p>{{ dateFormat(cardContent.remind) }}</p>
    </div>
    <div
      v-if="blueBottom"
      class="blue-bottom"
    />
  </router-link>
</template>
<script>
export default {
  name: "LicenseCard",
  props: {
    warning: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    remind: {
      type: Boolean,
      default: false,
    },
    blueBottom: {
      type: Boolean,
      default: false,
    },
    cardContent: {
      type: Object,
      default() {
        return {};
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: "",
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: "",
    },
    btnIcon: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    tag: "div",
  }),
  computed: {
    remindWarning() {
      if (!this.isRemindDateExist) return false;
      const newDate = this.$moment(this.date);
      const secondDate = this.$moment(this.cardContent.remind);
      return newDate.diff(secondDate, 'days', true) > 0;
    },
    isRemindDateExist() {
      return this.$moment(this.cardContent.remind).format() !== 'Invalid date';
    }
  },
  mounted() {},
  methods: {
    onClick() {
      this.$emit("click");
    },
    dateFormat(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    btnClick() {
      this.$emit("btn-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/license-card";
</style>